/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step1Inputs */

const en_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const de_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf hochladen`)
};

const fr_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const es_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const it_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const nl_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const pl_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const fi_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const da_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

const sv_landing_workflow_step1 = /** @type {(inputs: Landing_Workflow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Resume`)
};

/**
* | output |
* | --- |
* | "Upload Resume" |
*
* @param {Landing_Workflow_Step1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_workflow_step1 = /** @type {((inputs?: Landing_Workflow_Step1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_workflow_step1(inputs)
	if (locale === "fr") return fr_landing_workflow_step1(inputs)
	if (locale === "es") return es_landing_workflow_step1(inputs)
	if (locale === "it") return it_landing_workflow_step1(inputs)
	if (locale === "nl") return nl_landing_workflow_step1(inputs)
	if (locale === "pl") return pl_landing_workflow_step1(inputs)
	if (locale === "fi") return fi_landing_workflow_step1(inputs)
	if (locale === "da") return da_landing_workflow_step1(inputs)
	if (locale === "sv") return sv_landing_workflow_step1(inputs)
	return en_landing_workflow_step1(inputs)
});